import styled, { css } from 'styled-components';

export const Wrapper = styled.section`
  ${({ theme, isChildrenSubscriptionList }) => css`
    flex: 1;
    background: ${theme.v2.colors.white.primary};

    border: ${isChildrenSubscriptionList ? `1px solid ${theme.v2.colors.neutral.highMedium}` : 'none'};
    border-radius: 16px;
    margin: ${isChildrenSubscriptionList ? '0 24px 24px' : '0px'};

    @media (max-width: ${theme.v2.breakpoints.lg}){
      margin-top: 8px;
    }
  `}
`;

export const SubscriptionAdapter = styled.li`
  ${({ theme, isChildrenSubscriptionList }) => css`
      list-style: none;
      padding: 0;
      margin: ${isChildrenSubscriptionList ? '0 24px' : '0px'};
      border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};

      &:last-of-type {
        border-bottom: none;    
      }

      @media (max-width: ${theme.v2.breakpoints.lg}){
        margin-top: 8px;
      }
    `}
`;

export const SkeletonWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.white.primary};
    padding: 24px;
    border-radius: 16px;    

    @media (max-width: ${theme.v2.breakpoints.lg}){
      margin: 8px 0px
    }
  `}
`;
